import { render, staticRenderFns } from "./home-control-chart.vue?vue&type=template&id=22b0ac9e&"
import script from "./home-control-chart.vue?vue&type=script&lang=js&"
export * from "./home-control-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports